export default function getCorrectCase(count, words) {
  const value = Math.abs(count) % 100;
  if (value > 1) {
    return words[1];
  }
  return words[0];
}
